<template>
  <div class="ucenter-info-main">
    <div class="ucenter-info-main-left">
        <div class="ucenter-info-package-all">
            <div class="package-tit-list">
                <div class="package-tit-item pacakge__type_choose static__package uppercase-text" :class="{'is_active': packageType === 'static'}" @click="changeChooseType('static')"><span>{{ $t("dashboard.type.static") }}</span></div>
                <div class="package-tit-item pacakge__type_choose  rotating__package uppercase-text" :class="{'is_active': packageType === 'rotating'}" @click="changeChooseType('rotating')"><span>{{ $t("dashboard.type.rotating") }}</span></div>
                <div class="package-tit-item pacakge__type_choose wallet__package uppercase-text" :class="{'is_active': packageType === 'wallet'}" @click="changeChooseType('wallet')"><span>{{ $t("dashboard.type.wallet") }}</span></div>
            </div>
            <div class="package-sub-list">
                
            </div>
        </div>
        <div class="ucenter-info-package-detail">
            <div class="package-used-all">
                <div v-if="packageType === 'rotating'" class="package-type">
                    <div class="package-type-top">
                        <div class="package-type-top-icon">
                            <img class="icon" src="@/assets/index/img/ucenter/info/icon_residential.svg" alt="">
                        </div>
                        <div class="package-type-top-title">
                            <div class="tit"><span>{{ $t("dashboard.rotating.title") }}</span></div>
                            <div class="tip"><span>{{ $t("dashboard.rotating.intro") }}</span></div>
                        </div>
                    </div>
                    <div class="package-type-center">
                      <PieChart class="piechart-box" :chart-colors="['#3B6CF4', '#FF8F0B']" :chart-field="'traffic'" :chart-data="residentialUsedArr"></PieChart>
                    </div>
                    <div class="package-type-foot">
                        <div class="time-box residential__time">
                            <span class="time-name">{{ $t("dashboard.rotating.expiry_time") }}</span>
                            <span class="time"> {{ trafficExpireTime }} </span>
                        </div>
                        <div class="help-box">
                        </div>
                        <div class="btn-box">
                            <a class="btn" href="/ucenter/use_proxy/"><span>{{ $t("dashboard.rotating.using") }}</span></a>
                            <!-- <a class="btn btn1 position-btn" href="/ucenter/wallet/" ><span>Auto-subscription</span></a> -->
                        </div>
                    </div>
                </div>
                <div v-if="packageType === 'static'" class="package-type">
                    <div class="package-type-top">
                        <div class="package-type-top-icon">
                            <img class="icon" src="@/assets/index/img/ucenter/info/icon_static.svg" alt="">
                        </div>
                        <div class="package-type-top-title">
                            <div class="tit"><span>{{ $t("dashboard.static.title") }}</span></div>
                            <div class="tip"><span>{{ $t("dashboard.static.intro") }}</span></div>
                        </div>
                    </div>

                    <PieChart class="package-type-center" :chart-colors="['#FFC041', '#6196FD']" :chart-field="''" :chart-data="staticISPArr"></PieChart>

                    <div class="package-type-foot">
                        <div class="help-box">
                        </div>
                        <div class="btn-box">
                            <a class="btn" href="/ucenter/staticisp/ips"><span>{{ $t("dashboard.static.using") }}</span></a>
                            <!-- <a class="btn btn1 position-btn" href="/ucenter/wallet/" ><span>Auto-subscription</span></a> -->
                        </div>
                    </div>
                </div>
                <div  v-if="packageType === 'wallet'" class="package-type">
                    <div class="user-wallet-info" data-main-type="wallet"  data-sub-type="wallet">
                        <div class="package-top">
                            <div class="wallet-icon">
                                <img class="icon" src="@/assets/index/img/ucenter/info/icon_wallet.svg" alt="">
                            </div>
                            <div class="wallet-title">
                                <div class="tit"><span>{{ $t("dashboard.wallet.title") }}</span></div>
                                <div class="tip"><span>{{ $t("dashboard.wallet.intro") }}</span></div>
                            </div>
                        </div>
                        <div class="package-content">
                            <div class="wallet-info">
                                <div class="info-item">
                                    <div class="tit">{{ walletInfo.remaining > 0 ? $t("dashboard.wallet.remaining") : $t("dashboard.wallet.overdraft") }}</div>
                                    <div class="price green"><span>$</span><span class="wallet__balance"> {{ formatMoney(walletInfo.remaining) }}</span></div>
                                </div>
                                <div class="info-item">
                                    <div class="tit">{{ $t("dashboard.wallet.total") }}</div>
                                    <div class="price blue"><span>$</span><span class="wallet__total">{{ formatMoney(walletInfo.total) }}</span></div>
                                </div>
                                <div class="info-item">
                                    <div class="tit">{{ $t("dashboard.wallet.usage") }}</div>
                                    <div class="price orange"><span>$</span><span class="wallet__use"> {{ formatMoney(walletInfo.used) }}</span></div>
                                </div>                                
                                <div class="info-item" :class="showCreditBalance ? 'visible' : 'invisible'">
                                    <div class="tit">{{ $t("dashboard.wallet.credit") }}</div>
                                    <div class="price green"><span>$</span><span class="wallet__balance"> {{ formatMoney(walletInfo.creditBalance) }}</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="package-foot">
                            <div class="help-box">
                            </div>
                            <div class="btn-box">
                                <a class="btn" href="/ucenter/wallet/" target="_self">
                                    <span>{{ $t("dashboard.wallet.action") }}</span><span class="btn-arrow"><img class="icon" src="@/assets/index/img/ucenter/info/icon_arrow.svg" alt=""></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="package-popular-all">
                <div v-if="packageType === 'rotating'" class="package-popular-box">
                    <div class="package-popular-box-tit"><span>{{ $t("dashboard.rotating.plan.from") }}</span></div>
                    <div class="package-popular-box-center">
                      <div class="package-popular-detail">
                        <div class="package-popular-price">
                            <span class="now-price">
                                <span>$</span><span>1</span><span class="unit">/GB</span>
                            </span>
                            <div class="package-popular-detail-tit package-popular-detail-tit-bg">
                              <span>30 {{ $t("dashboard.rotating.plan.days") }}</span>
                          </div>
                        </div>
                        
                        <div class="package-popular-advs">
                            <ul class="package-popular-ul">
                                <li class="package-popular-advs-item"><span>{{ $t("dashboard.rotating.plan.feature_1") }}</span></li>
                                <li class="package-popular-advs-item"><span>{{ $t("dashboard.rotating.plan.feature_2") }}</span></li>
                                <li class="package-popular-advs-item"><span>{{ $t("dashboard.rotating.plan.feature_3") }}</span></li>
                                <li class="package-popular-advs-item"><span>{{ $t("dashboard.rotating.plan.feature_4") }}</span></li>
                            </ul>
                        </div>
                      </div>
                    </div>
                    <div class="package-popular-foot">
                        <a href="/ucenter/residential/" class="btn"><span>{{ $t("dashboard.rotating.plan.action") }}</span><span class="btn-arrow"><img class="icon" src="@/assets/index/img/ucenter/info/icon_arrow.svg" alt=""></span></a>
                    </div>
                </div>
                <div v-if="packageType === 'static'" class="package-popular-box" >
                    <div class="package-popular-box-tit"><span>{{ $t("dashboard.static.plan.from") }}</span></div>
                    <div class="package-popular-box-center">
                        <div class="package-popular-detail">
                            <div class="package-popular-price">
                                <span class="now-price">
                                    <span>$</span><span>5</span><span class="unit">{{ $t("dashboard.static.plan.month") }}</span>
                                </span>
                            </div>
                            <div class="package-popular-advs">
                                <ul class="package-popular-ul">
                                    <li class="package-popular-advs-item"><span>{{ $t("dashboard.static.plan.feature_1") }}</span></li>
                                    <li class="package-popular-advs-item"><span>{{ $t("dashboard.static.plan.feature_2") }}</span></li>
                                    <li class="package-popular-advs-item"><span>{{ $t("dashboard.static.plan.feature_3") }}</span></li>
                                    <li class="package-popular-advs-item"><span>{{ $t("dashboard.static.plan.feature_4") }}</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="package-popular-foot">
                        <a href="/ucenter/staticisp/" class="btn"><span>{{ $t("dashboard.static.plan.action") }}</span><span class="btn-arrow"><img class="icon" src="@/assets/index/img/ucenter/info/icon_arrow.svg" alt=""></span></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="ucenter-info-package-chartbox">
            <div v-if="packageType === 'rotating'" class="chart-content residential__chart_line_box">
                <div class="chart-top">
                    <div class="chart-type">
                        <div class="chart-type-item chart__change_user is_active"><span>{{ $t("dashboard.rotating.traffic") }}</span></div>
                    </div>
                    <div class="chart-time">
                        <div class="chart-type-time-box chart__line_type_main">
                            <el-date-picker v-model="residentialDate.dateRange" type="daterange" align="right" unlink-panels range-separator="-" start-placeholder="startTime" end-placeholder="endTime" :picker-options="pickerOptions" @change="handleDateChange">
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="chart-detail">
                    <LineChart class="line-chart-content chart__line_type_main" :chart-data="trafficUsages" ></LineChart>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import {utcTimestampToLocalTime, changeFlowUnit } from '@/util/human'
import { getWalletInfo, getUserAuthorities, getProxyUser, getTrafficUsages } from '@/http/api/member'
import PieChart from './pie-chart.vue';
import LineChart from './line-chart.vue';

let StatsByHoursBetweenDays = 3;

export default {
  name: 'info',
  components: {
    PieChart,
    LineChart,
  },

  data() {
    return {
      packageType: "static",
      
      residentialStartTime: "",
      residentialEndTime: "",
      residentialUsedObj: { used: 0, all: 0, balance: 0, expire_time: "" },

      trafficExpireTime: "",
      
      staticISPObj: { ipNum: 0, ipValidNum: 0, ipInValidNum: 0 },

      residentialDate: { dateRange: this.getLastWeek(), type: "days" },
      
      trafficUsages : { dateList: [], usedList: [], residualList: []},
      
      showCreditBalance: false,
      walletInfo: {total: 0, used: 0, remaining: 0, creditBalance: 0},
    }
  },
  inject: ['updateCurrentMenuUrl'],
  computed: {
    staticISPArr() { return [
        { objname: "ipInValidNum", name: this.$t("dashboard.static.invalid_ips"), value: 0 },
        { objname: "ipValidNum", name: this.$t("dashboard.static.valid_ips"), value: 0 },
      ];
    },
    residentialUsedArr() { return [
        {
          objname: "balance",
          name: this.$t("dashboard.rotating.balance"),
          defaulvalue: 0,
          valuealue: "0MB",
          value: 0,
          chartUnit: "MB",
        },
        {
          objname: "used",
          name: this.$t("dashboard.rotating.used"),
          defaulvalue: 0,
          unitValue: "0MB",
          value: 0,
          chartUnit: "MB",
        },
      ];
    },
    pickerOptions() { return {
        shortcuts: [{
          text: this.$t("dashboard.rotating.period.today"),
          onClick(picker) {
            const today = new Date();
            picker.$emit('pick', [today, today]);
          }
        },{
          text: this.$t("dashboard.rotating.period.recent_week"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t("dashboard.rotating.period.recent_month"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t("dashboard.rotating.period.recent_quarter"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      };
    },
    isLogin() {
      return this.$store.state.isLogin
    },
  },
  created() {
    this.updateCurrentMenuUrl('/ucenter/info/');
    this.init();
  },

  methods: {
    formatMoney(value) {
      const amount = Number(value)
      if (!Number.isFinite(amount)) {
        return '0'
      }

      const rounded = Math.round((amount + Number.EPSILON) * 100) / 100
      return String(Object.is(rounded, -0) ? 0 : rounded)
    },
    init() {
      this.getScurce();
      this.getUserInfo();
      this.getAccountTraffic(this.residentialDate);
      this.loadWalletInfo();
      this.loadUserAuthories();
    },
    getLastWeek() {
      const end = new Date();
      const start = new Date();
      start.setDate(start.getDate() - 7);
      return [start, end];
    },
    getScurce() {
      let a = this.getQueryString("source");
      if (a) {
        if (a == "wallet") {
          this.packageType = "wallet";
        } else if (a == "renew") {
          this.packageType = "static";
        } else if (a == "residential") {
          this.packageType = "rotating";
        }
      }
    },

    getUserInfo() {
      let self = this;
      getProxyUser({}).then((ret) => {
        let info = ret.data;
        self.username = info.username;
        self.password = info.password;
        self.user_traffic_balance = info.balance ? changeFlowUnit(1000 * info.balance) : "0M"

        self.residentialUsedObj.used = 1000_000_000 * info.usage;
        self.residentialUsedObj.all = 1000_000_000 * info.plan;
        self.residentialUsedObj.balance = 1000_000_000 * info.balance;
        
        self.trafficExpireTime = ""
        self.residentialUsedObj.expire_time = ""
        if (info.is_inf != "0") {
          self.trafficExpireTime = self.$t("dashboard.rotating.unlimited");
          self.residentialUsedObj.expire_time = self.$t("dashboard.rotating.unlimited");
        } else if (info.is_inf == "0") {
          if (info.expire_time > 0) {
            self.trafficExpireTime = utcTimestampToLocalTime(info.expire_time* 1000, 2);
            self.residentialUsedObj.expire_time = self.flowForeignExpireTime;
          }
        }
        self.setRotatingChartPieData(self.residentialUsedObj, self.residentialUsedArr);

        self.staticISPObj.ipNum = info.isp_num;
        self.staticISPObj.ipValidNum = info.isp_valid_num;
        self.staticISPObj.ipInValidNum = info.isp_num - info.isp_valid_num;
        self.setStaticChartPieData(self.staticISPObj, self.staticISPArr);

      }).catch(e => {
        // self.$message.error(e.message ?? e.msg ?? "get user info error");
      })
    },

    loadWalletInfo() {
      var that = this
      getWalletInfo().then(res => {
        let wallet_info = res.data
            
        that.walletInfo.total = wallet_info.total_charged
        that.walletInfo.used = wallet_info.total_spend
        that.walletInfo.remaining = wallet_info.balance
        that.walletInfo.creditBalance = wallet_info.credit_balance
      }).catch(e => {
        // that.$message.error(e.message ?? e.msg ?? "get wallet info error");
      });
    },

    async loadUserAuthories() {
      let that = this;
      await getUserAuthorities({}).then(res => {
        if (res && res.data.show_credit_balance == 1) {
            that.showCreditBalance = res.data.show_credit_balance;        
        }
      }).finally(() => {
        that.loading = false;
      }).catch(e => {
        // that.$message.error(e.message ?? e.msg ?? "get user authorities error");
      });
    },

    setRotatingChartPieData(obj, arr) {
      for (let i = 0; i < arr.length; i++) {
        for (const key in obj) {
          if (arr[i].objname == key) {
            arr[i].defaulvalue = obj[key];
            arr[i].value = this.convertDataToMB(obj[key]);
            arr[i].unitValue = this.convertDataToTB(obj[key]);
          }
        }
      }
    },
    setStaticChartPieData(obj, arr) {
      for (let i = 0; i < arr.length; i++) {
        for (const key in obj) {
          if (arr[i].objname == key) {
            arr[i].value = obj[key];
          }
        }
      }
    },

    changeChooseType(type) {
      this.packageType = type
      if (type == "rotating") {
        this.getAccountTraffic(this.residentialDate);
      }
    },

    handleDateChange(val) {
      this.getAccountTraffic(this.residentialDate);
    },

    getAccountTraffic(data_params) {
      let self = this;
      let params  = Object.assign({}, {start_time: data_params.dateRange[0], end_time: data_params.dateRange[1], type: data_params.type}), dateDiff = 0;
      if (params.end_time && params.start_time) {
        dateDiff = self.getDaysDifference(params.end_time, params.start_time);
        let timezone = new Date().getTimezoneOffset();
        if (timezone <= -480) {
          params.start_time = self.setStartime(params.start_time) / 1e3 - 60 * (timezone + 480);
          params.end_time = self.setEndtime(params.end_time) / 1e3 - 60 * (timezone + 480);
        } else if (timezone > -480 && timezone <= 0) {
          params.start_time = self.setEndtime(params.start_time) / 1e3 - 60 * (timezone + 480);
          params.end_time = self.setEndtime(params.end_time) / 1e3 - 60 * (timezone + 480);
        } else {
          params.start_time = self.setEndtime(params.start_time) / 1e3 + 60 * (+timezone + 480);
          params.end_time = self.setEndtime(params.end_time) / 1e3 + 60 * (timezone + 480);
        }
      } else {
        params.start_time = new Date(new Date().toLocaleDateString()).setHours(0, 0, 0, 0) / 1e3;
        params.end_time = new Date(new Date().toLocaleDateString()).setHours(23, 59, 59, 0) / 1e3;
      }
      
      if (dateDiff < StatsByHoursBetweenDays) params.type = "hours";
    
      getTrafficUsages(params).then(ret => {
        let usages = ret.data || [];
        let dateList = [],
          usedList = [], 
          residualList = [];
        usages.sort((a, b) => a.date - b.date);
        for (let n = 0; n < usages.length; n++) {
          if (dateDiff > StatsByHoursBetweenDays) dateList.push(self.formatDate(1e3 * usages[n].date));
          else dateList.push(self.formatDateTime(1e3 * usages[n].date));

          usedList.push(self.roundTwoDecimal(1e3 * usages[n].usage, 2));
          residualList.push(self.roundTwoDecimal(1e3 * usages[n].residual || 0, 2));
        }

        self.trafficUsages = {
          dateList: dateList,
          usedList: usedList,
          residualList: residualList,        
        };
      }).catch(e => {
        // self.$message.error(e.message ?? e.msg ?? "get traffic usages error");
      })
    },

    getQueryString(e) {
      var t = new RegExp("(^|&)" + e + "=([^&]*)(&|$)"),
        a = window.location.search.substr(1).match(t);
      return a ? decodeURIComponent(a[2]) : "";
    },
    qkf() {
      window.dispatchEvent(new CustomEvent('open-wechat-qr'));
    },
    roundTwoDecimal(e, t = 2) {
      let a = 1 * e;
      if ((e + "").indexOf(".") != -1) {
        let i = (function (e) {
          let t = e.toString(),
            a = t.indexOf(".");
          return t.length - a - 1;
        })(e);
        if (typeof t != "number") t = 2;
        if (i > t) {
          let i = Math.pow(10, t);
          a = Math.round(e * i) / i;
        }
      }
      return a;
    },
    secondsToDays(e, t) {
      const a = e / 86400;
      if (t == -1) return Math.floor(a);
      else if (t == 1) return Math.ceil(a);
      else return a;
    },
    convertDataToMB(e) {
      e = Number(e);
      e = e / 1e3 / 1e3;
      e = this.roundTwoDecimal(e, 2);
      return e;
    },
    convertDataToTB(e) {
      e = Number(e);
      const t = ["B", "KB", "MB", "GB", "TB"];
      let a = 0;
      while (e >= 1e3 && a < t.length - 1) {
        e /= 1e3;
        a++;
      }
      e = e % 1 != 0 ? Math.round(100 * e) / 100 : Math.round(e);
      return `${e}${a < 2 ? "MB" : t[a]}`;
    },
    getDaysDifferenceUp(e, t) {
      if (t) {
        if (t < 1e12) t *= 1e3;
      } else t = Date.now();
      if (e < 1e12) e *= 1e3;
      const a = new Date(t),
        i = new Date(e) - a,
        n = Math.max(i / 864e5, 0);
      return Math.ceil(10 * n) / 10;
    },
    getDaysDifference(e, t) {
      if (t) {
        if (t < 1e12) t *= 1e3;
      } else t = Date.now();
      if (e < 1e12) e *= 1e3;
      const a = new Date(t),
        i = new Date(e) - a,
        n = Math.max(i / 864e5, 0);
      return Math.floor(n);
    },
    formatDate(e) {
      let t = parseFloat(e),
        a = new Date(t),
        i = a.getFullYear(),
        n = a.getMonth() + 1,
        r = a.getDate();
      return `${i}-${this.add0(n)}-${this.add0(r)}`;
    },
    formatDateTime(e) {
      let t = parseFloat(e),
        a = new Date(t),
        i = a.getFullYear(),
        n = a.getMonth() + 1,
        r = a.getDate(),
        o = a.getHours(),
        s = a.getMinutes(),
        l = a.getSeconds();
      return `${i}-${this.add0(n)}-${this.add0(r)} ${this.add0(o)}:${this.add0(s)}:${this.add0(l)}`;
    },
    add0(e) {
      return e < 10 ? "0" + e : e;
    },
    setStartime(e) {
      return new Date(e).setHours(0, 0, 0, 0);
    },
    setEndtime(e) {
      return new Date(e).setHours(23, 59, 59, 0);
    },

  },
}
</script>

<style lang="scss" scoped>
.ucenter-info-main {
    margin-top: 18px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding-bottom: 48px;
    box-sizing: border-box
}

.ucenter-info-main .ucenter-info-main-left {
    width: 100%;
    max-width: 1290px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all {
    width: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-tit-list {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-tit-list .package-tit-item {
    margin-right: 10px;
    width: 20%;
    max-width: 160px;
    height: 40px;
    background-color: #EAEDF3;
    border-radius: 8px 8px 0 0;
    font-size: 13px;
    font-family: "Cabin-Medium";
    font-weight: 500;
    color: #12182C;
    line-height: 40px;
    text-align: center;
    text-transform: uppercase;
    cursor: pointer
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-tit-list .package-tit-item.is_active {
    background-color: #fff;
    font-weight: bold;
    color: #3B6CF4
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list {
    width: 100%;
    height: auto;
    border-radius: 0 0 8px 8px;
    background-color: #fff
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list {
    width: 100%;
    height: 142px;
    border-radius: 0 8px 8px 8px;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item {
    flex: 1;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item .package-icon {
    margin-bottom: 12px;
    width: 38px;
    height: 38px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item .package-icon .icon {
    height: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item .package-name {
    margin-bottom: 8px;
    font-size: 13px;
    font-family: "Cabin-SemiBold";
    font-weight: 500;
    color: #12182C;
    text-align: center
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item .package-price {
    font-size: 12px;
    font-family: "Cabin-Medium";
    font-weight: 500;
    color: #6E727E;
    text-align: center
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item.is_active {
    border-bottom: 2px solid rgba(19,78,241,0.6);
    background-image: linear-gradient(to bottom, rgba(255,255,255,0) 40%, rgba(225,233,255,0.5) 100%)
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail {
    margin-top: 18px;
    width: 100%;
    display: flex;
    justify-content: space-between
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all {
    width: 100%;
    max-width: 860px;
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type {
    width: 100%;
    height: 406px;
    background-color: #fff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #d5ddf9;
    // box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.1);
    padding: 22px 36px;
    box-sizing: border-box
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-top {
    display: flex;
    justify-content: flex-start
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-top .package-type-top-icon {
    margin-right: 16px;
    width: 38px;
    height: 38px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-top .package-type-top-icon .icon {
    width: auto;
    height: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-top .package-type-top-title .tit {
    margin-bottom: 5px;
    font-size: 14px;
    font-family: "Cabin-SemiBold";
    color: #12182C
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-top .package-type-top-title .tip {
    font-size: 13px;
    font-family: "Cabin-Medium";
    font-weight: 400;
    color: #6E727E
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-center {
    width: 100%;
    height: 280px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-center .piechart-box {
    width: 100%;
    height: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .time-box {
    font-size: 13px;
    font-family: "Cabin-Medium";
    font-weight: 400;
    color: #12182C
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .time-box .time {
    font-weight: 500
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .help-box {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .help-box .help-icon {
    margin-right: 8px;
    width: 20px;
    height: 20px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .help-box .help-icon .icon {
    height: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .help-box .help-name {
    font-size: 14px;
    font-family: "Cabin-Medium";
    font-weight: 400;
    color: #6E727E;
    text-decoration: underline
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .help-box .help-name:hover {
    color: #3B6CF4
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .btn-box {
    position: relative
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .btn-box .btn {
    display: block;
    width: 186px;
    height: 40px;
    box-sizing: border-box;
    background: #3B6CF4;
    border: 1px solid #3B6CF4;
    border-radius: 4px 4px 4px 4px;
    line-height: 40px;
    text-align: center;
    font-size: 13px;
    font-family: "Cabin-Medium";
    font-weight: 500;
    color: #FFFFFF;
    text-decoration: none
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .btn-box .btn.btn1 {
    background-color: #fff;
    color: #3B6CF4
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .btn-box .position-btn {
    position: absolute;
    top: -12px;
    right: 0;
    transform: translate(0, -100%)
}


.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info {
    width: 100%;    
    box-sizing: border-box
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-top {
    width: 100%;
    display: flex;
    justify-content: flex-start
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-top .wallet-icon {
    margin-right: 16px;
    width: 38px;
    height: 38px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-top .wallet-icon .icon {
    height: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-top .wallet-title {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-top .wallet-title .tit {
    margin-right: 16px;
    font-family: "Cabin-Medium";
    font-size: 14px;
    color: #213265
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-top .wallet-title .tip {
    font-size: 13px;
    font-family: "Cabin-Regular";
    font-weight: 400;
    color: #7983A4
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content {
    margin-top: 26px;
    width: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info {
    width: 100%;
    max-width: 800px;
    display: flex;
    justify-content: space-between
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item {
    margin-right: 20px;
    text-align: center
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item .tit {
    margin-bottom: 15px;
    font-size: 18px;
    font-family: "Cabin-Regular";
    font-weight: 400;
    color: #223265
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item .price {
    font-size: 24px;
    font-family: "Cabin-Regular";
    font-weight: 400
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item .price.blue {
    color: #276DFD
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item .price.orange {
    color: #FFA32E
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item .price.green {
    color: #10C158
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot {
    margin-top: 184px;
    width: 100%;
    display: flex;
    justify-content: space-between
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot .btn-box {
    display: flex;
    justify-content: flex-start
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot .btn-box .btn {
    display: block;
    width: 186px;
    height: 40px;
    box-sizing: border-box;
    background: #3B6CF4;
    border: 1px solid #3B6CF4;
    border-radius: 4px 4px 4px 4px;
    line-height: 40px;
    text-align: center;
    font-size: 13px;
    font-family: "Cabin-Medium";
    font-weight: 500;
    color: #FFFFFF;
    text-decoration: none;
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot .btn-box .btn .btn-arrow {
    margin-left: 12px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot .help-box {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot .help-box .help-icon {
    margin-right: 8px;
    width: 20px;
    height: 20px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot .help-box .help-icon .icon {
    height: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot .help-box .help-name {
    font-size: 14px;
    font-family: "Cabin-Medium";
    font-weight: 400;
    color: #6E727E;
    text-decoration: underline
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot .help-box .help-name:hover {
    color: #3B6CF4
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all {
    width: 100%;
    max-width: 410px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box {
    width: 100%;
    height: 406px;
    padding: 34px 36px;
    background: #FFFFFF;
    // box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.1);
    border: 1px solid #d5ddf9;
    border-radius: 8px 8px 8px 8px;
    border: 2px solid #FF8F0B;
    box-sizing: border-box;
    display: flex;
    flex-direction: column
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-tit {
    font-size: 14px;
    font-family: "Cabin-Medium";
    font-weight: bold;
    color: #12182C
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center {
    width: 100%;
    margin-top: 20px;
    display: flex;
    min-height: 0
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center .package-popular-detail {
    width: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center .package-popular-detail .package-popular-detail-tit {
    width: max-content;
    // max-width: 100%;
    display: inline-block;
    box-sizing: border-box;
    text-align: center;
    font-family: "Cabin-SemiBold";
    font-size: 14px;
    font-weight: 400;
    color: #12182C;
    line-height: 22px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center .package-popular-detail .package-popular-detail-tit.package-popular-detail-tit-bg {
    padding: 0 16px;
    font-weight: 600;
    background: rgba(255,141,10,0.08);
    border-radius: 19px 19px 19px 19px;
    color: #FF8F0B
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center .package-popular-detail .package-popular-price {
    margin-bottom: 8px;
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center .package-popular-detail .package-popular-price .now-price {
    font-family: "Cabin-Bold";
    font-size: 30px;
    font-weight: bold;
    color: #12182C
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center .package-popular-detail .package-popular-price .now-price .unit {
    font-family: "Cabin-Regular";
    font-size: 13px;
    font-weight: 400;
    color: #12182C
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center .package-popular-detail .package-popular-price .old-price {
    font-size: 12px;
    font-family: "Cabin-Regular";
    font-weight: 400;
    color: #6E727E
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center .package-popular-detail .package-popular-advs {
    width: 100%;
    padding: 20px 0 0 0;
    box-sizing: border-box
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center .package-popular-detail .package-popular-advs .package-popular-ul {
    width: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center .package-popular-detail .package-popular-advs .package-popular-ul .package-popular-advs-item {
    margin-top: 10px;
    position: relative;
    padding-left: 32px;
    box-sizing: border-box;
    font-size: 13px;
    font-family: "Cabin-Regular";
    font-weight: 400;
    color: #6E727E
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-box-center .package-popular-detail .package-popular-advs .package-popular-ul .package-popular-advs-item::before {
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    content: '';
    width: 16px;
    height: 16px;
    background-image: url("@/assets/index/img/ucenter/info/icon_info_advs.svg");
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-foot {
    margin-top: auto;
    width: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-foot .btn {
    margin: 0 auto;
    width: 90%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FF8F0B;
    box-shadow: 0px 4px 10px 0px rgba(255,143,11,0.3);
    border-radius: 4px 4px 4px 4px;
    font-family: "Cabin-Bold";
    font-size: 14px;
    font-weight: bold;
    color: #FFFFFF
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-foot .btn .btn-arrow {
    margin-left: 12px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-popular-all .package-popular-box .package-popular-foot .btn .btn-arrow .icon {
    width: 14px;
    height: auto
}


.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox {
    margin-top: 18px;
    width: 100%
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content {
    position: relative;
    width: 100%;
    height: 367px;
    padding: 0 36px;
    box-sizing: border-box;
    background: #FFFFFF;
    // box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.1);
    border: 1px solid #d5ddf9;
    border-radius: 8px 8px 8px 8px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top {
    width: 100%;
    height: 59px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 59px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top .chart-type {
    width: max-content;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top .chart-type .chart-type-item {
    width: max-content;
    padding: 0 15px;
    box-sizing: border-box;
    font-family: "Cabin-Medium";
    font-size: 14px;
    font-weight: 500;
    color: #6E727E;
    cursor: pointer
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top .chart-type .chart-type-item.is_active {
    border-bottom: 2px solid #3B6CF4;
    color: #3B6CF4
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top .chart-time {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top .chart-time .chart-type-time-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 1
}


.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-detail {
    width: 100%;
    height: 305px
}

.ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-detail .line-chart-content {
    width: 100%;
    height: 100%
}

.ucenter-info-main .ucenter-info-main-right {
    padding-top: 40px;
    margin-left: 15px;
    width: 400px;
    box-sizing: border-box
}


.ucenter-info-main .ucenter-info-main-right .ucenter-right-other {
    margin-top: 18px;
    width: 100%;
    height: auto;
    padding: 0 26px;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.1);
    border-radius: 8px 8px 8px 8px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-top {
    width: 100%;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #F4F7FF
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-top .other-tit-item {
    height: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    flex: 1;
    font-family: "Cabin-Medium";
    font-size: 14px;
    font-weight: 500;
    color: #6E727E;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    word-break: normal;
    cursor: pointer
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-top .other-tit-item.is_active {
    border-bottom: 2px solid #3B6CF4;
    font-family: "Cabin-Bold";
    font-weight: bold;
    color: #3B6CF4
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center {
    width: 100%;
    height: 309px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box {
    width: 100%;
    height: 100%;
    display: none
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.suggestions-box {
    position: relative;
    background-image: url("@/assets/index/img/ucenter/info/suggestions_bg.svg");
    background-repeat: no-repeat;
    background-position: bottom right;
    background-size: 50% auto
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.suggestions-box .suggestions-content {
    position: absolute;
    top: 40px;
    left: 30px;
    width: 60%;
    padding-top: 20px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #C6D8FF;
    box-sizing: border-box
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.suggestions-box .suggestions-content .suggestions-tit {
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    font-family: "Cabin-SemiBold";
    font-size: 13px;
    font-weight: 600;
    color: #12182C;
    text-transform: uppercase
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.suggestions-box .suggestions-content .suggestions-tip {
    margin-top: 9px;
    margin-bottom: 15px;
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    font-family: "Cabin-Regular";
    font-size: 12px;
    font-weight: 400;
    color: #6E727E
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.suggestions-box .suggestions-content .suggestions-btn {
    width: 100%;
    height: 45px;
    border-radius: 0 0 8px 8px;
    background-color: #3B6CF4;
    overflow: hidden
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.suggestions-box .suggestions-content .suggestions-btn .btn {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Cabin-Bold";
    font-size: 14px;
    font-weight: bold;
    color: #FFFFFF;
    text-decoration: none
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.suggestions-box .suggestions-content .suggestions-btn .btn .suggestions-btn-icon {
    margin-right: 4px;
    width: 16px;
    height: 16px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.suggestions-box .suggestions-content .suggestions-btn .btn .suggestions-btn-icon .icon {
    width: auto;
    height: 100%;
    vertical-align: text-top
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.survey-box .survey-content {
    height: 100%;
    padding: 26px 26px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.survey-box .survey-content .survey-icon {
    margin-top: 26px;
    margin: 0 auto;
    width: 118px;
    height: 116px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.survey-box .survey-content .survey-icon .icon {
    width: auto;
    height: 116px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.survey-box .survey-content .survey-tip {
    font-family: "Cabin-SemiBold";
    font-size: 13px;
    font-weight: 600;
    color: #12182C;
    text-align: center
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.survey-box .survey-content .survey-btn {
    width: 100%
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.survey-box .survey-content .survey-btn .btn {
    width: 100%;
    height: 48px;
    background: #3B6CF4;
    box-shadow: 0px 4px 10px 0px rgba(59,108,244,0.3);
    border-radius: 4px 4px 4px 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Cabin-Bold";
    font-size: 14px;
    font-weight: bold;
    color: #FFFFFF;
    text-decoration: none
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.survey-box .survey-content .survey-btn .btn .survey-btn-icon {
    margin-right: 4px;
    width: 14px;
    height: 14px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.survey-box .survey-content .survey-btn .btn .survey-btn-icon .icon {
    width: auto;
    height: 100%;
    vertical-align: text-top
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.google-auth-box .google-auth-content {
    height: 100%;
    padding: 26px 26px;
    box-sizing: border-box
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.google-auth-box .google-auth-content .safe-icon {
    margin: 0 auto 15px;
    width: 166px;
    height: 108px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.google-auth-box .google-auth-content .safe-icon .icon {
    height: 100%
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.google-auth-box .google-auth-content .validate-tip {
    margin-bottom: 15px;
    font-weight: 400;
    font-size: 12px;
    color: #12182C;
    text-align: left
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.google-auth-box .google-auth-content .validate-advs-box {
    margin-bottom: 25px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.google-auth-box .google-auth-content .validate-advs-box .validate-adv-ul .validate-adv-item {
    margin-bottom: 8px;
    font-weight: 400;
    font-size: 12px;
    color: #12182C
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.google-auth-box .google-auth-content .validate-advs-box .validate-adv-ul .validate-adv-item .item-icon {
    display: inline-block;
    width: 12px;
    height: 12px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.google-auth-box .google-auth-content .validate-advs-box .validate-adv-ul .validate-adv-item .item-icon .icon {
    height: 100%
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.google-auth-box .google-auth-content .validate-btn .btn {
    width: 100%;
    height: 48px;
    background: #3B6CF4;
    box-shadow: 0px 4px 10px 0px rgba(59,108,244,0.3);
    border-radius: 4px 4px 4px 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Cabin-Bold";
    font-size: 14px;
    font-weight: bold;
    color: #FFFFFF;
    text-decoration: none
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.enterprise-auth-box .enterprise-auth-content .abab_abab {
    padding: 10px 0 0 0;
    box-sizing: border-box
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.enterprise-auth-box .enterprise-auth-content .title_bbb {
    font-weight: 400;
    font-size: 13px;
    color: #12182C;
    line-height: 15px;
    text-align: left;
    margin-bottom: 25px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.enterprise-auth-box .enterprise-auth-content .title_bbb span {
    color: #FFA32E
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.enterprise-auth-box .enterprise-auth-content .dddd_dddd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 25px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.enterprise-auth-box .enterprise-auth-content .dddd_dddd .ddd_ddd {
    width: 148px;
    height: 75px;
    background: #FFFAF3;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.enterprise-auth-box .enterprise-auth-content .dddd_dddd .ddd_ddd img {
    margin-bottom: 12px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.enterprise-auth-box .enterprise-auth-content .dddd_dddd .ddd_ddd div {
    font-weight: 400;
    font-size: 12px;
    color: #12182C;
    line-height: 14px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.enterprise-auth-box .enterprise-auth-content .bbb_bbb {
    width: 100%;
    max-width: 290px;
    height: 48px;
    background: #3B6CF4;
    box-shadow: 0px 4px 10px 0px rgba(59,108,244,0.3);
    border-radius: 4px 4px 4px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    border: none;
    outline: none;
    cursor: pointer;
    text-decoration: none;
    margin: auto
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.enterprise-auth-box .enterprise-auth-content .bbb_bbb img {
    margin-right: 8px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.enterprise-auth-box .enterprise-auth-content .bbb_bbb span {
    font-weight: bold;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 16px
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-other .other-center .opinion-box.is_active {
    display: block
}

.ucenter-info-main .ucenter-info-main-right .ucenter-right-google .other-center {
    height: 360px
}

.ucenter-info-main a.btn:not(.btn1),
.ucenter-info-main a.btn:not(.btn1):hover,
.ucenter-info-main a.btn:not(.btn1):focus,
.ucenter-info-main a.btn:not(.btn1) span,
.ucenter-info-main .bbb_bbb,
.ucenter-info-main .bbb_bbb:hover,
.ucenter-info-main .bbb_bbb:focus,
.ucenter-info-main .bbb_bbb span {
    color: #FFFFFF !important;
}

@media (max-width: 1910px) {
    .ucenter-info-main {
        display:flex;
        flex-direction: column
    }

    .ucenter-info-main .ucenter-info-main-right {
        width: 100%;
        max-width: 1190px;
        margin-top: 18px;
        margin-left: 0;
        padding-top: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly
    }

    .ucenter-info-main .ucenter-info-main-right .ucenter-right-helpcenter {
        max-width: 400px
    }

    .ucenter-info-main .ucenter-info-main-right .ucenter-right-other {
        margin-top: 0;
        max-width: 400px
    }
}

@media (max-width: 1350px) {
    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail {
        flex-direction:column-reverse;
        justify-content: center
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all {
        margin-top: 18px
    }
}

@media (max-width: 1200px) {
    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail {
        flex-direction: row;
        justify-content: flex-start
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all {
        margin-top: 0
    }
}

@media (max-width: 1100px) {
    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail {
        flex-direction:column-reverse;
        justify-content: center
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all {
        margin-top: 18px
    }
}

@media (max-width: 900px) {
    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-tit-list .package-tit-item {
        font-size:12px;
        height: 30px;
        line-height: 30px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item .package-name {
        font-size: 12px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item .tit {
        font-size: 15px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item .price {
        font-size: 15px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content {
        height: auto
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top {
        height: auto;
        line-height: 40px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top .chart-time {
        margin-top: 20px;
        height: 40px
    }
}

@media (max-width: 850px) {
    .user_order_notice {
        width: 100%;
        height: 30px
    }

    .user_order_notice .user_notice_cont .layui-carousel .carousel_list li .carousel_list_item {
        padding: 0 15px
    }

    .user_order_notice .user_notice_cont .layui-carousel .carousel_list li .carousel_list_item .user-notice-left .tit {
        font-size: 12px
    }

    .user_order_notice .user_notice_cont .layui-carousel .carousel_list li .carousel_list_item .user-notice-left .date {
        font-size: 12px
    }

    .user_order_notice .user_notice_cont .layui-carousel .carousel_list li .carousel_list_item .user_notice_right a {
        font-size: 12px
    }

    .ucenter-info-main .ucenter-info-main-right {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center
    }

    .ucenter-info-main .ucenter-info-main-right .ucenter-right-other {
        margin-top: 18px
    }
}

@media (max-width: 700px) {
    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-tit-list .package-tit-item {
        font-size:12px;
        height: 30px;
        line-height: 30px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item .package-name {
        font-size: 12px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-top .wallet-title .tip {
        font-size: 12px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item .tit {
        font-size: 12px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item .price {
        font-size: 12px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot .btn-box .btn {
        width: 200px;
        height: 35px;
        line-height: 35px;
        font-size: 12px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type {
        height: auto
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot {
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .time-box {
        margin-bottom: 10px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .help-box {
        margin-bottom: 10px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .btn-box {
        position: static
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .package-type-foot .btn-box .position-btn {
        margin-top: 12px;
        position: static;
        transform: translate(0, 0)
    }
}

@media (max-width: 550px) {
    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-tit-list .package-tit-item {
        width:20%
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item .package-name {
        font-size: 12px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-top .wallet-title .tip {
        font-size: 12px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item .tit {
        font-size: 12px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-content .wallet-info .info-item .price {
        font-size: 12px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content {
        padding: 0 16px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top .chart-type .chart-type-item {
        max-width: 160px;
        padding: 0 5px;
        font-size: 12px;
        text-align: center
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top .chart-time {
        margin-top: 20px;
        display: flex;
        flex-direction: column-reverse;
        justify-content: flex-start;
        align-items: flex-start;
        height: auto
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top .chart-time .chart-type-time-box {
        height: 40px
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-chartbox .chart-content .chart-top .chart-time .chart-sub-user-box {
        margin-left: 0;
        height: 40px
    }
}

@media (max-width: 450px) {
    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-tit-list .package-tit-item {
        font-size:0.08rem;
        margin-right: 0.04rem
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list {
        height: 1.3rem
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item {
        justify-content: flex-start;
        padding: .2rem 0 0;
        box-sizing: border-box
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item .package-icon {
        width: .3rem;
        height: .3rem
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item .package-name {
        height: .3rem;
        font-size: 0.08rem
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-all .package-sub-list .package-type-list .package-sub-item .package-price {
        font-size: 0.08rem
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot {
        margin-top: 15px;
        flex-wrap: wrap
    }

    .ucenter-info-main .ucenter-info-main-left .ucenter-info-package-detail .package-used-all .package-type .user-wallet-info .package-foot .help-box {
        margin-top: 10px
    }
}
</style>
